import { render, staticRenderFns } from "./TabsQuotesCategories.vue?vue&type=template&id=deecff6e"
import script from "./TabsQuotesCategories.vue?vue&type=script&lang=js"
export * from "./TabsQuotesCategories.vue?vue&type=script&lang=js"
import style0 from "./TabsQuotesCategories.vue?vue&type=style&index=0&id=deecff6e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports